module.exports = {"TXTCLI_Share_link":{"id":"TXTCLI_Share_link","defaultMessage":"Share link","track":"Share link"}}